<template>
  <div class="max-w-body-width mx-auto flex flex-col full-hd:flex-row">
    <template v-for="(post, i) in posts" :key="post.title.rendered">
      <PostPreview
        class="mb-md full-hd:mb-0 full-hd:mr-lg"
        :fading-back="scrollActive && i === 2"
        :fading-front="scrollActive && i === 0"
        :post="post"
      />
    </template>
  </div>
</template>

<script>
import PostPreview from "./PostPreview";
import { usePostManager } from "../../api/posts/postManager";
import { computed } from "vue";

export default {
  name: "PostPreviewOutlet",
  components: {
    PostPreview
  },
  props: {
    visibleposts: {
      type: Number,
      default: 2
    }
  },
  setup(props) {
    // console.log(props);
    const { posts } = usePostManager();
    const scrollActive = computed(() => {
      return posts.length > 3;
    });
    // console.log(posts);
    return {
      posts,
      scrollActive
    };
  }
};
</script>

<style>
.preview::after {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  transition: all 300ms ease;
  opacity: 0;
}
.preview.preview-fade-left::after {
  opacity: 1;
  background-image: linear-gradient(
    to left,
    #ededed,
    rgba(216, 216, 216, 0) 100%
  );
}
.preview.preview-fade-right::after {
  opacity: 1;
  background-image: linear-gradient(
    to right,
    #ededed,
    rgba(216, 216, 216, 0) 100%
  );
}
</style>
